/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .factory('NodeWithLinksInterceptor', [function () {
        return {
            response: function (res) {
                if (angular.isArray(res.resource)) {
                    return res.resource.map(_decorate);
                } else {
                    return _decorate(res.resource);
                }
            }
        }

        function _decorate(resource) {
            Object.defineProperties(resource, {
                hasEsignature: {
                    get: function () {
                        return this.has_esignature;
                    }
                }
            });

            return resource;
        }
    }]);
